var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPastaPana3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.84,257.64l-74.31-54.82a3.24,3.24,0,0,0-2.73-.54c-4.12,1.07-13.93,5.89-1.07,26.95a3.35,3.35,0,0,0,.8.88l71.09,53.61a6.73,6.73,0,0,0,10.65-4.09C458.87,271.5,457.23,259.66,452.84,257.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.91,264.24c.06.33,2.89,19.4-3.12,19.52s-6.47-11.49-5.53-17.87,4.29-8,4.29-8S453.62,256.94,454.91,264.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.76,262.48c-.11.14-17.16-12.78-38.08-28.85S371.89,204.41,372,204.27s17.16,12.77,38.08,28.85S447.86,262.34,447.76,262.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.94,268.66c-.1.14-17.66-13.17-39.21-29.72s-38.93-30.1-38.82-30.24,17.66,13.17,39.21,29.73S447.05,268.52,446.94,268.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.07,274.56c-.1.14-17.53-13.07-38.91-29.5s-38.64-29.86-38.53-30,17.53,13.06,38.92,29.5S446.18,274.42,446.07,274.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.65,279.86c-.11.14-17.18-12.75-38.13-28.79s-37.84-29.16-37.74-29.3,17.18,12.75,38.13,28.79S446.76,279.72,446.65,279.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,181l-72.36-14.1a2.59,2.59,0,0,0-2.16.55c-2.61,2.18-8,9,8.45,19.8a2.6,2.6,0,0,0,.88.36L468.45,202a5.37,5.37,0,0,0,6.28-6.59C473.1,189,467.87,181,464,181Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.76,185.08c.16.22,8.73,13,4.43,15.15s-8.6-6.07-10.11-11,.37-7.24.37-7.24S464.33,180.26,467.76,185.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.62,184.19c0,.17-16.67-2.82-37.15-6.67s-37.08-7.13-37-7.31,16.66,2.82,37.15,6.68S461.65,184,461.62,184.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.08,189.24c0,.17-16.93-3-37.74-7.07s-37.66-7.53-37.62-7.7,16.93,3,37.74,7.07S462.12,189.06,462.08,189.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.92,193.75c0,.17-17.12-3-38.17-7s-38.09-7.44-38.06-7.61,17.13,2.95,38.18,7S465,193.58,464.92,193.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.15,199.18c0,.17-16.77-3.25-37.37-7.65s-37.27-8.11-37.24-8.28,16.77,3.25,37.37,7.65S467.19,199,467.15,199.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.12,101l50.78-44.8a2.39,2.39,0,0,0,.81-1.87c-.13-3.12-2.07-10.9-19.15-4.94a2.4,2.4,0,0,0-.76.44L375.38,92.5a4.93,4.93,0,0,0,1.29,8.26C382.25,103.17,391,103.83,393.12,101Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.06,101.46c-.24,0-14.35-.93-13.5-5.26s9.23-2.87,13.66-1.2,5.06,4.31,5.06,4.31S393.5,101.66,388.06,101.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.16,97.48c-.11-.12,11.38-10.56,25.66-23.32s25.94-23,26.05-22.88S432.49,61.84,418.21,74.6,392.26,97.61,392.16,97.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.22,95c-.11-.13,11.66-10.66,26.28-23.53s26.56-23.21,26.67-23.09S429.51,59,414.89,71.91,388.33,95.12,388.22,95Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.34,94.53c-.1-.12,11.74-10.81,26.46-23.88s26.75-23.57,26.86-23.45S424.92,58,410.19,71.09,383.45,94.66,383.34,94.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.14,93.12c-.1-.13,11.76-10.39,26.5-22.93s26.77-22.61,26.87-22.48S419.76,58.1,405,70.64,378.25,93.24,378.14,93.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6,107.07c.28,1.07,16.66,11.54,29.28,8.7s14.81-1.71,14.7,1.16-3.74,6.84-2.56,15.4c1.36,9.91,4.46,18.89,7.47,22s7.83,3.12,8.87.51,2.52-2.89,4.75-1.56,5.13,2.76,5.61-2.82,5.3-2.1,5.3-2.1,3.55,1.94,4.41-2.15c.76-3.59-.59-4.33.09-4.19,3.16.69,6.3-.31,7-2.42s-1.51-5.64.15-7.27,4.35.93,5.64-1.5-3.63-5.24-1.45-7.63,5.26-1.18,5.58-4.11-4.91-3.91-3.83-6.31,5.88-.24,5.21-4.93-14.56-8.33-24.69-7.6c-7.28.52-10.91,3.39-14.37,5.16-2.88,1.48-5.16-.58-4.07-4.07s5.45-8.28,4.57-17.54S82.4,63.53,81,62s-6.41-1.41-8,2.84L71.4,69.12s-3.17-6.31-6.1-5.59-3,8.21-3,8.21-5.23-5.59-8-4.18-.94,9-.94,9-5.34-2.72-7.76-1.6-.58,7.35-.58,7.35-5.47-2.25-6.89.65,2.49,8.52,2.49,8.52-5.77-1.54-7.28.94S35.6,100,35.6,100,26.35,98.73,28.6,107.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.39,135.54a21,21,0,0,1,0-2.18,31.22,31.22,0,0,0-.55-5.91A29.83,29.83,0,0,0,81,119.2a29.41,29.41,0,0,0-6.59-8.4,30.93,30.93,0,0,0-4.54-3.2c-1.56-.9-3.14-1.65-4.64-2.36a55.29,55.29,0,0,1-7.83-4.19A19.54,19.54,0,0,1,53,97,14.42,14.42,0,0,1,52,95.64a2.76,2.76,0,0,1-.25-.51c.05,0,.43.66,1.32,1.74a20.56,20.56,0,0,0,4.47,3.86,58.9,58.9,0,0,0,7.82,4.06c1.51.7,3.1,1.45,4.69,2.35a31.15,31.15,0,0,1,4.63,3.26,29.66,29.66,0,0,1,9.54,17,28.07,28.07,0,0,1,.39,6c0,.71-.12,1.25-.16,1.62A2.18,2.18,0,0,1,84.39,135.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.05,116.63s-.71-.29-2-.79a35.7,35.7,0,0,0-5.61-1.68,33.6,33.6,0,0,0-8.63-.66,48.17,48.17,0,0,1-5.17.15,11.21,11.21,0,0,1-5.39-1.56,16.5,16.5,0,0,1-4.15-3.76,32.23,32.23,0,0,1-2.91-4.3A29.21,29.21,0,0,1,70,95.85a22.47,22.47,0,0,1-.5-5.88,13.64,13.64,0,0,1,.15-1.6,2.57,2.57,0,0,1,.11-.55c.06,0,0,.77,0,2.15a24.26,24.26,0,0,0,.66,5.8,29.73,29.73,0,0,0,3.21,8A32.23,32.23,0,0,0,76.51,108a15.91,15.91,0,0,0,4,3.63,10.76,10.76,0,0,0,5.14,1.5c1.76.1,3.48-.06,5.12-.12a32.19,32.19,0,0,1,8.73.78,31.46,31.46,0,0,1,5.61,1.85c.63.29,1.12.53,1.44.7A3.15,3.15,0,0,1,107.05,116.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.06,107a24.06,24.06,0,0,1-2.21-1.81,46.52,46.52,0,0,0-5.58-4,47.43,47.43,0,0,0-6.13-3.06,22.68,22.68,0,0,1-2.64-1.1,11.79,11.79,0,0,1,2.78.75,35.13,35.13,0,0,1,6.27,3,34.64,34.64,0,0,1,5.55,4.15A10.86,10.86,0,0,1,74.06,107Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.53,126.34a50.42,50.42,0,0,0-4.88-7.44,50.45,50.45,0,0,0-6.52-6.07,9.45,9.45,0,0,1,2.26,1.37,26.66,26.66,0,0,1,8.17,9.68A9.5,9.5,0,0,1,91.53,126.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.14,69.31a2.46,2.46,0,0,1,.26.42c.15.28.38.7.65,1.26a25.91,25.91,0,0,1,1.62,4.93,35,35,0,0,1-1,17c-.46,1.62-1,3.16-1.59,4.62a11.71,11.71,0,0,0-1,4.29,4.65,4.65,0,0,0,1.56,3.46,9.55,9.55,0,0,0,3,1.77,11.71,11.71,0,0,0,5,1,6.12,6.12,0,0,0,1.79-.51,1.59,1.59,0,0,1-.41.28,3.91,3.91,0,0,1-1.36.44,11.39,11.39,0,0,1-5.12-.89,10,10,0,0,1-3.15-1.8A5.74,5.74,0,0,1,78.08,104a5.33,5.33,0,0,1-.5-2.14,12.11,12.11,0,0,1,1-4.48c.57-1.47,1.11-3,1.57-4.58A36.12,36.12,0,0,0,81.3,76a29.94,29.94,0,0,0-1.45-4.93A15.08,15.08,0,0,1,79.14,69.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.89,37.73c-.93.52-1.13,1.8-1.16,2.9a9.43,9.43,0,0,0,.34,2.64,71.09,71.09,0,0,0,3.66,11.43,21.91,21.91,0,0,0,6.68,8.71A8.07,8.07,0,0,1,154.23,65a2.07,2.07,0,0,1,.25,2.26c-.62.94-2,.87-3.11.84A16,16,0,0,0,141,72.14a47.77,47.77,0,0,0-7.48,8.56c-.95,1.28-1.94,2.93-1.21,4.34a2.92,2.92,0,0,0,2.6,1.39,8.75,8.75,0,0,0,3-.7s-1.81,5.63-.19,6.82,4.64-1.61,4.64-1.61-1.62,5.08,1.18,5.29,5.51-2,5.51-2-1.66,4.64,1.33,4.64,4.93-3.56,4.93-3.56.22,4.21,2.81,4.32S162.34,96,162.34,96s.3,4.1,3.1,3.56,3.67-5.72,3.67-5.72,2.57,3.77,4.74,2.59a4.64,4.64,0,0,0,1.76-2.17,9.48,9.48,0,0,0,.62-5.92c-.68-3.31-2.12-9.31-3.88-11.45-2.48-3-7.45-5.78-6.8-8s1.84-2.35,5.94-2.78,13.82-9.93,15.33-12.63S186,47.65,182,48.62l-1.08-.22s1.73-4.53-.65-5.07-5.07,1.76-5.07,1.76.75-5.11-.76-6-5.5,2.37-5.5,2.37-.65-5.72-3.13-5.72-4,3.89-4,3.89-1.08-5-2.81-4.86-3.88,5-3.88,5-2.27-4.54-3.89-4.32-2.37,5.94-2.37,5.94S146.14,35.91,142.89,37.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.85,54.33a10.08,10.08,0,0,1-1.22,1c-.8.62-2,1.5-3.35,2.68A23.83,23.83,0,0,0,165,62.66a13.11,13.11,0,0,0-2.41,7.16,21.2,21.2,0,0,0,1.59,7.5c.81,2.25,1.61,4.28,2.08,6a16.23,16.23,0,0,1,.67,4.27,8.63,8.63,0,0,1-.06,1.18,1.27,1.27,0,0,1-.06.4,12.33,12.33,0,0,1-.08-1.57,19,19,0,0,0-.82-4.17c-.51-1.74-1.34-3.73-2.18-6a21.21,21.21,0,0,1-1.67-7.68,13.43,13.43,0,0,1,2.55-7.42,22.89,22.89,0,0,1,4.4-4.66c1.42-1.16,2.63-2,3.47-2.57A8.14,8.14,0,0,1,173.85,54.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.47,75.5a5.73,5.73,0,0,1-.75-2.35A11.2,11.2,0,0,1,168,62.47a5.86,5.86,0,0,1,2.16-1.19c0,.08-.8.5-1.93,1.48a11.87,11.87,0,0,0-4.13,10.34C164.24,74.59,164.55,75.48,164.47,75.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.09,46.34a13.13,13.13,0,0,1,0,1.61,27.1,27.1,0,0,0,.28,4.34,24.11,24.11,0,0,0,1.8,6.16c.48,1.11,1.12,2.23,1.62,3.48a7.48,7.48,0,0,1,.6,4.16,9.24,9.24,0,0,1-1.72,3.83,24.59,24.59,0,0,1-2.53,2.93,60.42,60.42,0,0,1-4.82,4.39c-1.43,1.17-2.62,2.09-3.45,2.71a8.22,8.22,0,0,1-1.32.92,10.14,10.14,0,0,1,1.2-1.08L148.05,77c1.39-1.22,3-2.68,4.72-4.44a27.23,27.23,0,0,0,2.46-2.89A9.07,9.07,0,0,0,156.85,66a7.18,7.18,0,0,0-.56-3.89c-.48-1.21-1.11-2.34-1.59-3.48a23.2,23.2,0,0,1-1.72-6.3,22.07,22.07,0,0,1-.12-4.4c0-.52.09-.92.14-1.19A1.19,1.19,0,0,1,153.09,46.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.73,63.16A18.86,18.86,0,0,1,153,58.9a18.61,18.61,0,0,1-2.78-5c.13-.07,1.39,2.13,3.21,4.66S156.85,63.06,156.73,63.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.94,190.46c-.7.77-.49,2-.18,3a9.33,9.33,0,0,0,1.12,2.34,70.66,70.66,0,0,0,6.89,9.4,21.32,21.32,0,0,0,8.85,6,7.85,7.85,0,0,1,2.16.88,2,2,0,0,1,.91,2c-.27,1.06-1.56,1.41-2.6,1.73a15.61,15.61,0,0,0-8.32,7A46.13,46.13,0,0,0,28.51,233c-.48,1.47-.88,3.29.22,4.37a2.85,2.85,0,0,0,2.83.49,8.32,8.32,0,0,0,2.54-1.58s.07,5.75,1.93,6.35,3.78-2.91,3.78-2.91.07,5.17,2.72,4.51S47,240.6,47,240.6s-.11,4.79,2.65,3.87,3.45-4.8,3.45-4.8,1.49,3.81,3.92,3.11,2.81-4.59,2.81-4.59,1.53,3.7,3.95,2.34,1.62-6.41,1.62-6.41,3.54,2.69,5.17.93a4.52,4.52,0,0,0,1-2.54,9.17,9.17,0,0,0-1.25-5.65c-1.65-2.84-4.82-7.93-7.1-9.36-3.22-2-8.64-3-8.74-5.29s1-2.73,4.62-4.4,9.68-13.4,10.24-16.36-2.59-5.11-6-3l-1.06.13s.19-4.71-2.16-4.47-4.14,3.18-4.14,3.18-.87-4.94-2.53-5.27-4.35,3.89-4.35,3.89-2.36-5.08-4.64-4.31-2.49,4.81-2.49,4.81-2.52-4.25-4.08-3.62-2.06,5.78-2.06,5.78-3.48-3.48-4.91-2.79-.36,6.21-.36,6.21S26.37,187.79,23.94,190.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.58,196.23a8.37,8.37,0,0,1-.82,1.3c-.54.82-1.36,2-2.26,3.5a23.62,23.62,0,0,0-2.48,5.6A12.77,12.77,0,0,0,52,214a20.69,20.69,0,0,0,3.78,6.43c1.44,1.82,2.8,3.44,3.78,4.92a16.1,16.1,0,0,1,1.93,3.74,8.33,8.33,0,0,1,.3,1.1,1.62,1.62,0,0,1,.07.39,20.4,20.4,0,0,0-2.61-5c-1-1.43-2.37-3-3.85-4.83a20.78,20.78,0,0,1-3.9-6.57,13.06,13.06,0,0,1,.06-7.62,22.28,22.28,0,0,1,2.63-5.66c1-1.5,1.81-2.65,2.41-3.43A8.34,8.34,0,0,1,57.58,196.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45,218.63A5.53,5.53,0,0,1,54,216.69a10.91,10.91,0,0,1,.65-11.15,5.8,5.8,0,0,1,1.63-1.77c.07.06-.58.72-1.32,2a11.57,11.57,0,0,0-.62,10.8C55,217.86,55.52,218.58,55.45,218.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,195.26a14.27,14.27,0,0,1,.47,1.49,24.46,24.46,0,0,0,1.6,3.91,23.06,23.06,0,0,0,3.55,5.12c.78.88,1.71,1.71,2.57,2.72A7.24,7.24,0,0,1,46,212.15a9.15,9.15,0,0,1-.4,4.06,25.77,25.77,0,0,1-1.43,3.48,61.78,61.78,0,0,1-3.1,5.53c-1,1.52-1.77,2.73-2.34,3.55A9.4,9.4,0,0,1,37.8,230a9.37,9.37,0,0,1,.77-1.37l2.2-3.64c.91-1.54,2-3.4,3-5.54a24.41,24.41,0,0,0,1.38-3.42,8.83,8.83,0,0,0,.38-3.83,6.91,6.91,0,0,0-1.71-3.41c-.82-1-1.74-1.81-2.54-2.71a22.45,22.45,0,0,1-3.52-5.29,21.15,21.15,0,0,1-1.47-4c-.11-.49-.2-.87-.23-1.13S36,195.26,36,195.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.52,209.64a18,18,0,0,1-4.8-2.75,18.21,18.21,0,0,1-4.09-3.73c.11-.11,1.95,1.53,4.4,3.31S44.6,209.51,44.52,209.64Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.06,455.57c0,.14-93.31.26-208.38.26s-208.39-.12-208.39-.26,93.29-.26,208.39-.26S458.06,455.42,458.06,455.57Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.42,144.33l13-.76a42,42,0,1,0-9-12.06v0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.42,144.33l.24-.81c.17-.57.42-1.38.74-2.45l2.93-9.61.06-.18.13.14v0l-.17.12a41.93,41.93,0,0,1-4.44-20.13,41.31,41.31,0,0,1,.72-6.48,45.94,45.94,0,0,1,1.91-6.72,41.55,41.55,0,0,1,7.75-13.09,42.28,42.28,0,0,1,30.92-14.41,42.21,42.21,0,0,1,34.37,16.74c.51.71,1,1.39,1.53,2.1s.89,1.48,1.33,2.22l.67,1.11.55,1.15c.37.78.74,1.55,1.1,2.32s.6,1.59.9,2.38a20.56,20.56,0,0,1,.79,2.41,36.4,36.4,0,0,1,1.09,4.9,42.88,42.88,0,0,1-1.3,19.28,42.16,42.16,0,0,1-37.42,29.49,45.33,45.33,0,0,1-7-.09,53.86,53.86,0,0,1-6.42-1.15,41.92,41.92,0,0,1-18-9.94l.08,0-9.73.51-2.47.12-.83,0,.87-.07,2.5-.17,9.65-.63h.05l0,0a41.75,41.75,0,0,0,18,9.77,55.28,55.28,0,0,0,6.38,1.13,45.75,45.75,0,0,0,6.94.06,41.79,41.79,0,0,0,28.06-13.65,42,42,0,0,0,8.93-15.61,42.45,42.45,0,0,0,1.27-19A37.09,37.09,0,0,0,450,101.3a20.11,20.11,0,0,0-.79-2.38c-.29-.78-.55-1.58-.88-2.36s-.72-1.52-1.09-2.28l-.55-1.15L446,92c-.43-.73-.87-1.46-1.31-2.19s-1-1.38-1.51-2.07a41.79,41.79,0,0,0-34-16.57,41.88,41.88,0,0,0-30.61,14.21,41.15,41.15,0,0,0-7.71,12.94A46.55,46.55,0,0,0,369,105a41.61,41.61,0,0,0,3.56,26.44l.34.71-.52-.59h0l.18,0c-1.33,4.14-2.35,7.33-3,9.49l-.79,2.46C368.53,144,368.42,144.33,368.42,144.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.86,109.69a12.94,12.94,0,0,0-3.44-7,12.53,12.53,0,0,0-6.59-3.94,10.3,10.3,0,0,0-7.88,1.66,10.17,10.17,0,0,0-3.19,3.7,10.09,10.09,0,0,0-3.05-3.22,10.28,10.28,0,0,0-7.93-1.45,12.53,12.53,0,0,0-6.48,4.11,13,13,0,0,0-3.25,7.13,15.85,15.85,0,0,0,2.1,9.74,22.47,22.47,0,0,0,7.83,7.14c5.1,3,11.81,6.71,11.81,6.71s5.57-4.28,10.58-7.39a22.46,22.46,0,0,0,7.65-7.36A15.9,15.9,0,0,0,430.86,109.69Z",
    style: {
      fill: "#A9D061"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.09,200.75c-8.66-28.23-18.26-53-22.2-68-11.11-42.35-21.37-91.64-83.3-87.21a131,131,0,0,0-18.2,5.18,73.5,73.5,0,0,0-48.08,60.9L178,141.24c-.64,43.42,10,70.53,22.06,101.89.05.12,0-.07,0,0l134.3,16.57h29.53S362,229.78,353.09,200.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.35,61.71l3.87-3.7,41.87,16.88a11.69,11.69,0,0,1,11,11.31l-.37,136.42c.05,9.25-1.8,17.26-7.38,24.63L282.49,255c-13.4,17.7-41,16.24-51.6-3.26a15.16,15.16,0,0,1-1.48-3.53,29,29,0,0,1-.62-3c-1.25-11-1.32-20.49-1.32-20.49-.74-12.05-1-17-1-16.88s-25.65-2.95-32.58-35.87c-3.45-16.37-2.8-38.89-1.83-61.06C193.41,80.21,214.69,61.68,239.35,61.71Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.87,134.5a4.26,4.26,0,0,0,4.32,4.09,4.07,4.07,0,0,0,4.19-4.06,4.26,4.26,0,0,0-4.31-4.09A4.08,4.08,0,0,0,245.87,134.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.71,135.14a4.26,4.26,0,0,0,4.32,4.09,4.08,4.08,0,0,0,4.2-4.06,4.27,4.27,0,0,0-4.32-4.09A4.09,4.09,0,0,0,202.71,135.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.45,119.65c.56.53,3.66-2,8.24-2.24s8.05,1.91,8.52,1.32c.23-.26-.36-1.23-1.87-2.22a11.71,11.71,0,0,0-6.86-1.75,11.2,11.2,0,0,0-6.52,2.48C196.61,118.39,196.18,119.42,196.45,119.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,118.09c.61.47,3.44-2.38,8-3.07s8.2,1.07,8.61.44c.2-.29-.48-1.2-2.1-2a11.71,11.71,0,0,0-7-1,11.33,11.33,0,0,0-6.24,3.13C243,116.82,242.69,117.89,243,118.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.93,153.46c0-.26-2.87-.61-7.51-1-1.17-.06-2.29-.24-2.53-1s.11-2.11.61-3.5q1.42-4.34,3-9.08c4.16-12.92,7.12-23.52,6.6-23.68s-4.33,10.18-8.49,23.09c-1,3.19-2,6.22-2.87,9.13-.37,1.35-1.06,2.89-.37,4.62a2.92,2.92,0,0,0,2,1.61,8.23,8.23,0,0,0,2,.18C224,153.84,226.92,153.72,226.93,153.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.48,207.81a84.52,84.52,0,0,0,43.84-14.08s-10,23.53-43.38,22.08Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.77,103.88c.59,1.18,4.54,0,9.38-.11s8.9.77,9.36-.43c.2-.57-.65-1.63-2.38-2.58a14.46,14.46,0,0,0-7.23-1.64,14.08,14.08,0,0,0-7,2C241.24,102.22,240.51,103.33,240.77,103.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.11,111.37c.86,1,4-.24,7.75-.48s7,.34,7.73-.78c.29-.55-.27-1.56-1.72-2.48a11.27,11.27,0,0,0-12.47,1C197.12,109.78,196.73,110.88,197.11,111.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.29,144.42s-17.62,4.26-42.63-49.6c-8.52-18.33-25-36.81-25-36.81l15.51-2.23s46.25,13,47,13.61,11.67,23.92,11.67,23.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.51,142.26c-.11-2.47,2.45-8.44,4.87-8.94,6.47-1.34,18.24-1.41,19.18,15.14,1.28,22.61-21.69,19.24-21.77,18.59S289.92,150.8,289.51,142.26Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.22,158.09c.09-.08.41.25,1.09.52a4,4,0,0,0,2.95-.11c2.34-1,4.13-4.92,4-9a13.07,13.07,0,0,0-1.42-5.58c-.78-1.61-1.92-2.71-3.14-2.85a2,2,0,0,0-2.26,1.21c-.27.65-.1,1.09-.22,1.14s-.5-.35-.37-1.3a2.54,2.54,0,0,1,.81-1.47,3,3,0,0,1,2.14-.7c1.75,0,3.41,1.54,4.32,3.28a13.42,13.42,0,0,1,1.72,6.22c.11,4.57-2,9-5.19,10.1a4.23,4.23,0,0,1-3.64-.4C298.29,158.64,298.14,158.14,298.22,158.09Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.48,170.79a8.09,8.09,0,1,1-8.09-8.09A8.09,8.09,0,0,1,307.48,170.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.31
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.1,148.38c0,3-5.31,5.45-11.86,5.45s-11.86-2.44-11.86-5.45,5.31-5.45,11.86-5.45S269.1,145.37,269.1,148.38Z",
    style: {
      fill: "#ff9772"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.31
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.77,148.38c0,3-3.61,5.45-8.06,5.45s-8.05-2.44-8.05-5.45,3.6-5.45,8.05-5.45S210.77,145.37,210.77,148.38Z",
    style: {
      fill: "#ff9772"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.06,94.68A21,21,0,0,0,339,91,34.22,34.22,0,0,1,322,86.39a25.38,25.38,0,0,0,12.44-13.18,40.8,40.8,0,0,0,2.9-18.15c-.36-7.8-2.82-16.28-9.41-20.48-4.77-3-10.81-3.23-16.42-2.51-6.49.84-12.94,2.84-18.27,6.65s-9.44,9.55-10.43,16L310,98a34,34,0,0,0,31,1.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.16,111.68a5.36,5.36,0,0,1-.33-.75l-.84-2.2c-.74-1.9-1.79-4.66-3.2-8a185.28,185.28,0,0,0-12.67-25.47A100.69,100.69,0,0,0,299,62.51,61.35,61.35,0,0,0,289.54,54c-2.94-2.15-5.44-3.72-7.17-4.79l-2-1.22a4.44,4.44,0,0,1-.69-.45,5.34,5.34,0,0,1,.74.36c.48.25,1.17.63,2.06,1.14,1.77,1,4.31,2.54,7.29,4.67a59.81,59.81,0,0,1,9.63,8.5A97.31,97.31,0,0,1,308.56,75a172.16,172.16,0,0,1,12.57,25.61c1.37,3.39,2.36,6.17,3.05,8.09.31.94.57,1.68.75,2.23A4.05,4.05,0,0,1,325.16,111.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.62,160.58c-1.32-1.93-1.91-4.14-4.14-3.74-2.71.49-7.87,4.15-11.32,6.11-.68.91,1.22,2.57,1.55,3.23s.08.34.63.78c2,1.59,4.08,3.17,6.56,3.63a6.69,6.69,0,0,0,6.92-2.94A6.84,6.84,0,0,0,243.62,160.58Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,170.6c0-.09.49.05,1.3,0a5.32,5.32,0,0,0,3.07-1.31,5.94,5.94,0,0,0,1.9-4.44,9,9,0,0,0-2.11-5.67c-.68-.81-1.51-1.87-2.15-1.81a3.28,3.28,0,0,0-1.25.53l-1.35.74c-1.76,1-3.35,1.83-4.69,2.54-2.69,1.42-4.38,2.23-4.45,2.11s1.49-1.17,4.08-2.75c1.3-.79,2.85-1.72,4.58-2.73l1.33-.78a3.93,3.93,0,0,1,1.7-.68,2.48,2.48,0,0,1,1.83.86,15.22,15.22,0,0,1,1.19,1.33,9.76,9.76,0,0,1,2.25,6.35,6.58,6.58,0,0,1-2.39,5,5.3,5.3,0,0,1-3.54,1.15C237.75,170.93,237.32,170.65,237.34,170.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.51,251.12c-.44,1.52-36.33,66.81-44.43,96.85-4.87,18-2,42.57,6.19,47.3,14.31,8.24,28.39-1.2,37.47-8.95s33.52-123.58,33.52-123.58Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.72,252.08a52.15,52.15,0,0,0-20.22,9c-9.57,7.17-47.65,52.73-47.65,52.73L85.6,327.09,70.46,396.67s15.16-5.89,45.93-27.55a625.18,625.18,0,0,0,49.42-38.78Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.86,270.67a1.47,1.47,0,0,1,0,.32c0,.24-.12.54-.2.92-.19.84-.46,2-.81,3.53-.73,3.1-1.79,7.51-3.08,13-2.62,10.93-6.34,26-10,42.76-1.83,8.38-3.44,16.39-4.78,23.7-.67,3.65-1.22,7.15-2,10.37A59.89,59.89,0,0,1,95.09,374a40.11,40.11,0,0,1-6.9,11.37c-.51.6-1,1.08-1.44,1.52a13.52,13.52,0,0,1-1.12,1l-.72.62-.25.19a2.08,2.08,0,0,1,.22-.23l.68-.65c.3-.28.67-.63,1.08-1.08s.91-.93,1.39-1.55a40.54,40.54,0,0,0,6.72-11.37,61.14,61.14,0,0,0,2.74-8.73c.78-3.21,1.32-6.69,2-10.36,1.32-7.31,2.91-15.33,4.74-23.72,3.67-16.76,7.44-31.83,10.15-42.74,1.36-5.43,2.47-9.83,3.24-12.91.39-1.5.69-2.68.91-3.51l.24-.91A1.43,1.43,0,0,1,118.86,270.67Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.39,234.63l-10.47,96.09L191.25,416l-11,39.61H367.84l-25-46.82s2.86-43.14,3.93-57.7c2.57-35,2.46-118.39,2.46-118.39L296.8,220.47c-27,22.14-49.3,27.51-69.33,4.22C227.47,224.69,189.05,231.47,184.39,234.63Z",
    style: {
      fill: "#A9D061"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.56,297.91l29.53,67.7,39.18-34.89,6.23-97.63-7.21,2.23c-9.28,1.86-19.69,8.8-29.69,20.06Z",
    style: {
      fill: "#A9D061"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.31,394.2c-6.71-14.65-13.41-27.23-13.69-43.34-.38-21.64,6.35-29.58,4.79-54.53",
    style: {
      fill: "#A9D061"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.41,296.33a1.11,1.11,0,0,1,0,.26c0,.2,0,.45.06.76,0,.71.1,1.69.18,2.93s.06,2.84.09,4.65-.06,3.88-.24,6.16-.43,4.76-.8,7.42-.88,5.48-1.43,8.44-1.13,6.07-1.56,9.31a98.05,98.05,0,0,0-.84,10.08,72.92,72.92,0,0,0,.33,10.1,66.52,66.52,0,0,0,1.74,9.25,107.23,107.23,0,0,0,5.36,15c1.81,4.18,3.36,7.52,4.4,9.85.51,1.13.9,2,1.19,2.68l.3.7a1,1,0,0,1,.08.25s-.05-.07-.13-.22-.21-.41-.34-.69l-1.28-2.64c-1.1-2.3-2.7-5.62-4.56-9.78a104.58,104.58,0,0,1-5.49-15.06,66.78,66.78,0,0,1-1.78-9.31,72.61,72.61,0,0,1-.34-10.18,93.83,93.83,0,0,1,.86-10.13c.44-3.26,1-6.37,1.59-9.33s1.07-5.77,1.48-8.41.69-5.12.85-7.39.24-4.33.32-6.13,0-3.37,0-4.64-.06-2.22-.08-2.93c0-.31,0-.56,0-.77A.76.76,0,0,1,178.41,296.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.52,383.53a4,4,0,0,1-.72.27c-.48.15-1.17.43-2.1.66a42.65,42.65,0,0,1-7.95,1.41A45.42,45.42,0,0,1,244.3,371.6a46.53,46.53,0,0,1-7-9.73,43.37,43.37,0,0,1-3.18-7.43c-.32-.9-.46-1.63-.6-2.12a3.76,3.76,0,0,1-.17-.74,3.64,3.64,0,0,1,.27.72c.17.47.35,1.19.69,2.07a47.88,47.88,0,0,0,10.34,16.9,45.14,45.14,0,0,0,25.21,13.61,47.62,47.62,0,0,0,19.79-.62c.93-.2,1.63-.44,2.12-.56A6.68,6.68,0,0,1,292.52,383.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.27,338.62s-30.88-104-65-107.12c-43.22-4-1.43,127.92-1.43,127.92Z",
    style: {
      fill: "#A9D061"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.27,338.62l-.34.13-1,.34-3.87,1.25-14.37,4.58-48.63,15.32-.24.08-.08-.25c-1.28-3.92-2.6-8-3.86-12.26-6.76-22.32-10.8-43.14-12.24-58.37-.74-7.6-.89-13.79-.89-18.07,0-2.13.1-3.79.13-4.91l.06-1.28c0-.29,0-.44,0-.44a2.12,2.12,0,0,1,0,.44v1.28c0,1.12-.06,2.78,0,4.91.07,4.27.27,10.45,1.06,18,1.52,15.18,5.61,35.95,12.37,58.25,1.25,4.22,2.57,8.33,3.85,12.25l-.32-.16,48.67-15.15L404,340.17l3.89-1.18,1-.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.05,359.05l13.72,45.55S296.58,416.69,273.39,422s-24.08,25.93-24.08,25.93L275,455.57s117.44,5.07,127.55,0c20.63-10.35,4.49-88.38.73-104-1.27-5.29-2.35-10.14-2.35-10.14Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,422.51c-.1,0-.56-1.51-1.77-3.8a27.64,27.64,0,0,0-2.46-3.81,30.57,30.57,0,0,0-3.78-4,30.25,30.25,0,0,0-4.52-3.21,26.53,26.53,0,0,0-4.1-1.92c-2.43-.89-4-1.15-4-1.25a4.93,4.93,0,0,1,1.13.13,12,12,0,0,1,1.3.28,15.86,15.86,0,0,1,1.7.49,25.08,25.08,0,0,1,4.22,1.85,28.65,28.65,0,0,1,4.62,3.24,29.14,29.14,0,0,1,3.83,4.14,25.23,25.23,0,0,1,2.39,3.93,15.13,15.13,0,0,1,.72,1.62,9.82,9.82,0,0,1,.45,1.25A5.31,5.31,0,0,1,379,422.51Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.64,429.72l6.9-3.26L206,429.61s-3.34,3.54-2.31,7.45,8.2,4.75,8.2,4.75a11.21,11.21,0,0,0,2.06,7.7c2.51,3.35,12.09.9,12.09.9l-1.32,2.86c-1.62,3.06,2.29,6.84,4.1,7.3s8.84-1.52,12-3.6,14.82-1.14,14.82-1.14,14.58,4.65,20.78,2.43,8-6.74,8-6.74-1-27.29-10-31.63c-4.55-2.21-31.06-12.37-39-15.75a11.22,11.22,0,0,0-8.37-.18c-8.57,3.24-24.14,9.72-28,12.69,0,0-6.81,4.28-5.45,8.36C194.39,427.36,196.57,430.73,201.64,429.72Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.71,417.27c.11.15-3,2.56-6.9,5.38s-7.19,5-7.29,4.85,3-2.56,6.9-5.38S221.61,417.12,221.71,417.27Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.74,432.35c.08.18-3.89,1.93-8.52,4.58s-8.25,5.06-8.37,4.88a11.79,11.79,0,0,1,2.24-1.76c1.44-1,3.47-2.36,5.8-3.7a59.66,59.66,0,0,1,6.16-3.06A11.1,11.1,0,0,1,228.74,432.35Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.58,443.34c.09.16-2.85,2-6.56,4s-6.8,3.62-6.89,3.46,2.85-2,6.56-4S238.49,443.18,238.58,443.34Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.06,208.63c2.16-8.08,4.33-16.38,3.44-24.69-.18-1.75-.46-3.69.55-5.13,1.18-1.67,3.72-1.88,5.52-.92a9.54,9.54,0,0,1,3.83,4.64,24.9,24.9,0,0,1-.55,21.64",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.52,215.36V272a1.45,1.45,0,1,0,2.89,0V215.36a1.45,1.45,0,1,0-2.89,0Z",
    style: {
      fill: "#facd8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.94,198.15s14.44,3.07,19.58,5.58,11.36,5.87,17.35,6.58,25-7.89,25-7.89v1.07l-7.54,3.95-6.82,2.92,8.5-2.68-.36,1.32s-9.57,5.38-15.43,6.58-16.51.71-20.1-5.15-16.58-8.25-21.47-8.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.2,202.15c1.82-1.37,4.25,3.28,4.9,4.47a22.68,22.68,0,0,1-1.49,24.19c-1.07,1.5,1.12,3.37,2.21,1.86a25.81,25.81,0,0,0,4.45-20.17,26.21,26.21,0,0,0-3.78-9.14c-1.64-2.48-4.76-6-8-3.57-1.48,1.12.18,3.49,1.66,2.36Z",
    style: {
      fill: "#facd8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.73,202.72c-.95-1.63-1.08-5.25-1-7.14a6.84,6.84,0,0,1,1.81-4.13,20,20,0,0,1,3.51-3,8.75,8.75,0,0,1-4.3,14.24",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.1,192.55a36.24,36.24,0,0,1-1.32,4.58,36,36,0,0,1-1.42,4.56,24.39,24.39,0,0,1,2.74-9.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.94,207.26a7.26,7.26,0,0,1,3.26-5.94c2.21-1.3,5.41-.63,7.43.69a11.62,11.62,0,0,1,4.23,5.88c.88,2.49,1.46,5.58-.18,7.9a3.59,3.59,0,0,1-2.91,1.66,2.58,2.58,0,0,1-2.44-1.66c-.55-1.77-3.33-1-2.78.77a5.65,5.65,0,0,0,8,3.07c3.46-1.78,4.37-6,3.82-9.5a16.31,16.31,0,0,0-4.8-9.43,11,11,0,0,0-10.46-2.47c-3.72,1.15-6,5.32-6.1,9,0,1.86,2.85,1.86,2.89,0Z",
    style: {
      fill: "#facd8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.16,203.89c0,.15,0,.14,0,0,0,.11,0,.12,0,0h0a2.34,2.34,0,0,1,.23-.22,5,5,0,0,1,.73-.41,2.27,2.27,0,0,1,1.53-.23,6.47,6.47,0,0,1,2.07.81,5.25,5.25,0,0,1,1.54,1.64,16.81,16.81,0,0,1,2.42,5.05,2.53,2.53,0,0,1-.16,2.12,1.65,1.65,0,0,1-.5.33.6.6,0,0,1-.23,0,1.48,1.48,0,0,0-2,.52,1.44,1.44,0,0,0,.51,2,3.71,3.71,0,0,0,4.93-1.81c1-2.15.11-4.54-.79-6.55a14.72,14.72,0,0,0-3.38-5.11,7.77,7.77,0,0,0-5.29-1.9c-2,.18-4.43,1.59-4.56,3.78a1.45,1.45,0,0,0,1.44,1.44,1.47,1.47,0,0,0,1.44-1.44Z",
    style: {
      fill: "#facd8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.92,207.6l.29-.13c-.19.08-.22.09-.09.05s.35-.12.53-.15.54,0,.11,0c.16,0,.31,0,.47,0l.64,0c-.35,0-.06,0,.11,0a6.16,6.16,0,0,1,.93.27c-.43-.15.18.09.27.14s.28.16.41.24l.39.27c-.34-.25,0,0,.11.1a8.34,8.34,0,0,1,.77.8c0,.05.32.46.09.11l.32.45c.18.3.36.6.51.91.08.14.14.28.21.43s.09.19,0,0l.09.22a10.11,10.11,0,0,1,.35,1.06c0,.17.09.35.13.53s.05.24,0,0c0,.09,0,.18,0,.27a4.42,4.42,0,0,1,0,.63c0-.35-.06.08-.08.19.09-.37,0,0-.06.08-.14.32.24-.22-.09.11s.21-.1-.11.08.35,0,0,0,.38,0,0,0c-.22,0-.18,0,.11,0a1.21,1.21,0,0,1-.25-.08,1.93,1.93,0,0,0-2.37,1.34A2,2,0,0,0,198,218a4.14,4.14,0,0,0,4.71-1.88c1-1.57.8-3.68.21-5.37-1-3.08-3.13-5.86-6.32-6.9a7.44,7.44,0,0,0-5.65.45,1.92,1.92,0,0,0,1.94,3.32Z",
    style: {
      fill: "#facd8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.67,219.24v28a1.44,1.44,0,0,0,2.88,0v-28a1.44,1.44,0,0,0-2.88,0Z",
    style: {
      fill: "#facd8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.12,219.12c2.56,4.67,7.28,10,13.15,8.32,5.24-1.49,7.81-7.6,8.2-12.9a37.56,37.56,0,0,0-1.18-10.82c-.39-1.75-2.91-1-2.52.74,1.31,5.87,2.33,13.31-2,18.14a5.85,5.85,0,0,1-7.1,1.74c-2.78-1.29-4.61-4.08-6.31-6.63-1-1.45-3.23-.06-2.25,1.41Z",
    style: {
      fill: "#facd8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,210.57c-.12.31.06-.07.11-.16s0,0,0,0l.15-.17c.07-.07.39-.32.14-.14a4.07,4.07,0,0,1,.49-.31l.21-.1c-.05,0-.28.1,0,0l.45-.14.45-.09c-.34.06.11,0,.23,0h.42c.36,0-.22-.07.12,0,0,0,.45.15.22.06s.06,0,.12.06l.35.18a7.86,7.86,0,0,1,2,1.48,6.47,6.47,0,0,1,1.32,2,4.44,4.44,0,0,1,.32,1.14c0-.2,0,.06,0,.08v.32a1.54,1.54,0,0,1-.1.54s-.09.25,0,.08a1.17,1.17,0,0,1-.15.27s-.16.21,0,.08l-.21.21s-.21.16-.06,0l-.25.16-.27.14c.17-.08-.09,0-.14,0-.2.06-.39.12-.59.16l-.3.06c-.25.07.28,0,.09,0s-.6,0-.9,0l-.24,0c.36,0-.05,0-.1,0l-.55-.12a7.74,7.74,0,0,1-1.15-.38c.28.12-.2-.1-.27-.14s-.29-.18-.44-.27,0,0,0,0l-.23-.21a1.66,1.66,0,0,1-.13-.14c.13.13.12.17,0,0a1.44,1.44,0,0,0-2.49,1.46c.95,1.6,3.07,2.35,4.82,2.61,2.17.32,4.67-.25,5.91-2.23,1.48-2.37.27-5.4-1.3-7.38a9.77,9.77,0,0,0-2.59-2.2,6.2,6.2,0,0,0-2.87-1,5.34,5.34,0,0,0-5.32,3.2,1.46,1.46,0,0,0,1,1.78,1.48,1.48,0,0,0,1.77-1Z",
    style: {
      fill: "#facd8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.44,218.52c0-.06.74.25,2.05.54a9.23,9.23,0,0,0,2.37.22,5.51,5.51,0,0,0,2.86-.81l0,0h0c1.78-.92,2.72-3.66,1.74-6a10.25,10.25,0,0,0-3.48-4.35,6.66,6.66,0,0,0-4.25-1.44,4.9,4.9,0,0,0-2.85,1c-.58.45-.78.83-.83.8s0-.1.13-.28a3.48,3.48,0,0,1,.57-.68,5,5,0,0,1,3-1.25,7,7,0,0,1,4.55,1.42,10.43,10.43,0,0,1,3.68,4.55c1.06,2.53,0,5.57-2,6.58l0,0a5.76,5.76,0,0,1-3.13.83,9.13,9.13,0,0,1-2.44-.34,11.18,11.18,0,0,1-1.49-.53C189.6,218.64,189.43,218.55,189.44,218.52Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.94,217.91a8.45,8.45,0,0,0,1.15.08,4.28,4.28,0,0,0,2.75-1.23,5.53,5.53,0,0,0,1.43-4.19,8.64,8.64,0,0,0-2.3-5,17.09,17.09,0,0,0-2.15-2,7.66,7.66,0,0,0-2.34-1.34A6.25,6.25,0,0,0,192,204a4.47,4.47,0,0,0-2.39,1.86c-.39.63-.49,1-.54,1s0-.1.05-.3a3.49,3.49,0,0,1,.31-.82,4.56,4.56,0,0,1,2.44-2.11,6.58,6.58,0,0,1,4.78.08,7.85,7.85,0,0,1,2.49,1.4,16.63,16.63,0,0,1,2.23,2.08,9,9,0,0,1,2.38,5.34,5.78,5.78,0,0,1-1.66,4.48,4.28,4.28,0,0,1-3,1.17,3.12,3.12,0,0,1-.87-.14C198,218,197.93,217.92,197.94,217.91Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.06,215.79a4.07,4.07,0,0,0,1.14,0,4.29,4.29,0,0,0,2.55-1.59,3,3,0,0,0,.67-1.91,12.21,12.21,0,0,0-.28-2.46,12.43,12.43,0,0,0-.85-2.59,14.27,14.27,0,0,0-1.38-2.58c-.29-.4-.62-.79-.93-1.18a8.29,8.29,0,0,0-1-1.07,7.15,7.15,0,0,0-2.25-1.45,6.83,6.83,0,0,0-4.49-.23,5.08,5.08,0,0,0-1.59.72,3.08,3.08,0,0,0-.87,1,2.69,2.69,0,0,0-.37,1.06s-.17-.45.19-1.16a3.13,3.13,0,0,1,.88-1.1,5.07,5.07,0,0,1,1.66-.84,7.12,7.12,0,0,1,4.76.13,7.44,7.44,0,0,1,2.42,1.53,7.75,7.75,0,0,1,1,1.12c.31.38.64.77,1,1.19a14,14,0,0,1,1.43,2.69,13,13,0,0,1,.86,2.7,12.75,12.75,0,0,1,.23,2.56,3.36,3.36,0,0,1-.82,2.13,4.3,4.3,0,0,1-2.8,1.57,2.5,2.5,0,0,1-.89-.07C203.15,215.85,203.06,215.81,203.06,215.79Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.36,218.16s.27.36.89.86a5.67,5.67,0,0,0,3.06,1.24,5.8,5.8,0,0,0,4.42-1.78,8.71,8.71,0,0,0,2.44-5.41,14.36,14.36,0,0,0-.7-6,15.78,15.78,0,0,0-2.37-4.4,21.85,21.85,0,0,0-3.3-3.27s.11,0,.29.14a6.43,6.43,0,0,1,.79.52,13.07,13.07,0,0,1,2.51,2.38,15.2,15.2,0,0,1,2.53,4.47,14.34,14.34,0,0,1,.77,6.26,9.09,9.09,0,0,1-2.63,5.7,6,6,0,0,1-4.79,1.79,5.49,5.49,0,0,1-3.15-1.45,4,4,0,0,1-.61-.72C199.39,218.27,199.34,218.17,199.36,218.16Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.61,212.08c.07,0,.22.53.2,1.42a4.41,4.41,0,0,1-1.34,3.21,4,4,0,0,1-3.37.88c-.9-.21-1.31-.64-1.27-.68s.51.22,1.33.31a4,4,0,0,0,3-.9,4.51,4.51,0,0,0,1.31-2.85A7.42,7.42,0,0,1,207.61,212.08Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.45,199.53a2.13,2.13,0,0,1,.48.2,7.86,7.86,0,0,1,1.25.79,10.86,10.86,0,0,1,3.26,4.33,23.05,23.05,0,0,1-.82,17.54c-1.76,3.08-4.88,5.25-8,5.38a9.3,9.3,0,0,1-4.27-.85,11.62,11.62,0,0,1-3.16-2.07,20.6,20.6,0,0,1-3.26-4.35c-.29-.52-.53-.94-.73-1.28a1.71,1.71,0,0,1-.22-.47,3.56,3.56,0,0,1,.31.41l.82,1.23a22.86,22.86,0,0,0,3.32,4.19,11.82,11.82,0,0,0,3.09,1.95,9.1,9.1,0,0,0,4.07.76,9.81,9.81,0,0,0,7.6-5.16,19.3,19.3,0,0,0,2.15-9.35A19.62,19.62,0,0,0,210.1,205a11.12,11.12,0,0,0-3-4.32C206.08,199.87,205.42,199.58,205.45,199.53Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.15,218.4a1.84,1.84,0,0,1-.13.78,9.66,9.66,0,0,1-.81,2,8.52,8.52,0,0,1-2,2.51,6,6,0,0,1-3.73,1.33,7.88,7.88,0,0,1-3.83-1,8.51,8.51,0,0,1-2.51-2A6.61,6.61,0,0,1,194,220.2a1.74,1.74,0,0,1-.2-.77,12.15,12.15,0,0,0,1.6,2.37,8.41,8.41,0,0,0,6.05,2.7,5.68,5.68,0,0,0,3.44-1.18,8.9,8.9,0,0,0,2-2.33C207.81,219.47,208.06,218.37,208.15,218.4Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.43,209.36a14.4,14.4,0,0,0,7.6.76l1.93,5a14.74,14.74,0,0,1-5.8,1C182.64,216.05,182.43,209.36,182.43,209.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.1,211.06a1.37,1.37,0,0,1-.41.15c-.28.08-.69.17-1.22.27a19.11,19.11,0,0,1-4.57.26,28.29,28.29,0,0,1-6.67-1.26,43.06,43.06,0,0,1-7.63-3.26,64.38,64.38,0,0,0-13.75-5.85,31.24,31.24,0,0,0-4.45-.86,14.12,14.12,0,0,1-1.66-.19,1.67,1.67,0,0,1,.44,0,10.92,10.92,0,0,1,1.24,0,26.05,26.05,0,0,1,4.52.7,59.26,59.26,0,0,1,13.9,5.75,36.5,36.5,0,0,0,14.09,4.61,21.75,21.75,0,0,0,4.51-.09C193.5,211.15,194.09,211,194.1,211.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.82,182.32h0a4.41,4.41,0,0,1,5.4-3.29l63.13,17.69a3.63,3.63,0,0,1,2.54,4.38h0a3.64,3.64,0,0,1-4.42,2.64l-63.4-16.17A4.41,4.41,0,0,1,81.82,182.32Z",
    style: {
      fill: "#A9D061"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,178s-20.7,3.45-23.56,11c-3.3,8.75-5.94,21.8-5.94,21.8a55.77,55.77,0,0,0,.13,6.95c.31,4.9,2.88,33.34,2.88,33.34l32.13,14.55a41.44,41.44,0,0,0,3.9-13.45c.62-7,2.92-20.43,2.92-20.43s9-.79,11.23-8.22c1.41-4.84-.89-7-.89-7s2.79-6-1.15-10.84a6.46,6.46,0,0,0-1.83-6.51c-.79-.78-4.69-2.59-8.63-4.55-4.28-2.14-9.61-3-13.12-.44S99.93,204,99.93,204l1.14-10s17.21-7,18.43-9.63C121.15,180.94,117.62,177.16,114,178Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.13,195.17s-.53-.24-1.48-.65a21.72,21.72,0,0,0-4.13-1.41,14.29,14.29,0,0,0-3-.36,7.25,7.25,0,0,0-3.28.66,77.44,77.44,0,0,0-6.57,4.46c-1.1.86-2.09,1.83-3.11,2.7s-2,1.72-3,2.5l-5.06,4.12L93.18,210a8.76,8.76,0,0,1-1.28,1A9,9,0,0,1,93,209.83c.77-.71,1.89-1.71,3.3-2.92l5-4.21c.94-.79,1.92-1.63,2.92-2.51s2-1.85,3.13-2.73a70.81,70.81,0,0,1,6.67-4.48,7.7,7.7,0,0,1,3.51-.66,13.24,13.24,0,0,1,3,.44,19.56,19.56,0,0,1,4.14,1.57c.47.24.81.45,1.05.59S126.14,195.15,126.13,195.17Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.31,208.69a11.05,11.05,0,0,1-.65-1.13,10.16,10.16,0,0,0-6.88-4.9,11.64,11.64,0,0,0-6.25.57,21,21,0,0,0-5.5,3.28c-1.56,1.22-2.9,2.42-4.08,3.37A27,27,0,0,1,111,212a5,5,0,0,1-1.16.62,9.13,9.13,0,0,1,1.05-.78c.68-.5,1.64-1.25,2.78-2.23s2.46-2.21,4-3.47a20.76,20.76,0,0,1,5.6-3.38,11.89,11.89,0,0,1,6.53-.56,10.17,10.17,0,0,1,4.79,2.4,9.35,9.35,0,0,1,2.18,2.87,6.23,6.23,0,0,1,.38.9C137.3,208.57,137.33,208.69,137.31,208.69Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.31,217.74a3.93,3.93,0,0,1-.59-.78,15.68,15.68,0,0,0-1.62-2.08,5.51,5.51,0,0,0-3.29-1.75,3.52,3.52,0,0,0-2.12.42,19.2,19.2,0,0,0-2.06,1.36c-2.81,2-5.37,3.75-7.24,5-.94.63-1.7,1.13-2.23,1.46a3.69,3.69,0,0,1-.86.49,3.45,3.45,0,0,1,.74-.65c.5-.39,1.23-.94,2.14-1.61,1.81-1.33,4.34-3.15,7.15-5.13a18.07,18.07,0,0,1,2.13-1.39,4.12,4.12,0,0,1,2.41-.44,5.79,5.79,0,0,1,3.5,2,12.59,12.59,0,0,1,1.53,2.22A3.52,3.52,0,0,1,137.31,217.74Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.75,227.7A4.27,4.27,0,0,1,90.9,227a9.53,9.53,0,0,1-4.71-8,4.25,4.25,0,0,1,.25-2c.09,0,0,.76.11,2A10.68,10.68,0,0,0,88,223.32a10.52,10.52,0,0,0,3.14,3.34C92.08,227.34,92.78,227.62,92.75,227.7Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.51,223.57a18.18,18.18,0,0,1-2,1.79c-1.27,1.08-3,2.61-4.75,4.43s-3.24,3.59-4.27,4.89a18.15,18.15,0,0,1-1.73,2.09,11.64,11.64,0,0,1,1.43-2.31,45.16,45.16,0,0,1,4.2-5,43.41,43.41,0,0,1,4.89-4.36A12,12,0,0,1,135.51,223.57Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.42,220.89a3.35,3.35,0,0,1-.17,1.75,13.5,13.5,0,0,1-1.78,3.85,10.8,10.8,0,0,1-2.94,3.08,2.75,2.75,0,0,1-1.66.6c0-.09.63-.26,1.45-.9A13.09,13.09,0,0,0,136,226.2a17.43,17.43,0,0,0,1.87-3.67C138.26,221.54,138.34,220.88,138.42,220.89Z",
    style: {
      fill: "#ff9a6c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pasta--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.36,410.4c1-5.71,5.36-10.08,10.55-12.32,6.52-2.82,14-2.25,20.87-1.15a1.62,1.62,0,0,0,1.93-1.1,1.59,1.59,0,0,0-1.1-1.93c-7.73-1.24-16-1.78-23.29,1.47-5.83,2.58-10.89,7.75-12,14.2-.34,2,2.69,2.82,3,.83Z",
    style: {
      fill: "#facd8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36,410.4a1.25,1.25,0,0,1-.37.85,1.72,1.72,0,0,1-2.46-.39,1.88,1.88,0,0,1-.33-.9,4.55,4.55,0,0,1,.14-1,14.52,14.52,0,0,1,.61-2.21,18.24,18.24,0,0,1,2.68-4.89,23.1,23.1,0,0,1,12-7.9c5.28-1.58,11.43-1.52,17.65-.65l2.32.34a1.59,1.59,0,0,1,1.12.71,2,2,0,0,1,.33,1.25,1.75,1.75,0,0,1-.59,1.17,1.88,1.88,0,0,1-1.2.45,7.9,7.9,0,0,1-1.16-.13l-1.1-.17a56.89,56.89,0,0,0-8.46-.64,25.1,25.1,0,0,0-13.65,3.67,17.15,17.15,0,0,0-6.35,7.1,20.4,20.4,0,0,0-1.14,3.36.67.67,0,0,1,0-.23l.11-.68a13.24,13.24,0,0,1,.81-2.53,17,17,0,0,1,6.34-7.33,25.24,25.24,0,0,1,13.84-3.84,55.06,55.06,0,0,1,8.54.62l1.11.16a7.27,7.27,0,0,0,1.06.13,1.29,1.29,0,0,0,.27-2.56l-2.3-.34c-6.18-.86-12.25-.92-17.45.6a22.91,22.91,0,0,0-11.8,7.67,18.45,18.45,0,0,0-2.7,4.76,15.17,15.17,0,0,0-.64,2.16,4.42,4.42,0,0,0-.15,1,1.5,1.5,0,0,0,.27.79,1.75,1.75,0,0,0,1.22.71,1.3,1.3,0,0,0,1-.28A2,2,0,0,0,141.36,410.4Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.1,396.18c4.75-4.38,11-6.56,17-8.53,3.19-1,6.77-2.27,10.13-1.3a9.9,9.9,0,0,1,5.85,5.58c1.66,3.49,1.72,7.54,1.86,11.32.07,2,3.21,2,3.14,0-.25-6.9-1-15.53-8-19.11-3.49-1.81-7.45-1.38-11.11-.36a88.32,88.32,0,0,0-10.61,3.72A35.71,35.71,0,0,0,173.88,394c-1.48,1.38.74,3.59,2.22,2.22Z",
    style: {
      fill: "#facd8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.14,430.45s9.91-39.3,66.52-33.23l23.22,3s10.67-2.51,12.82,2c0,0,4.65-2.5,6.4,1.8,0,0,4.49-.7,5.06,3.33,0,0,4.42-1.08,4.88,4a4.76,4.76,0,0,1,4,4.72s3.72.45,4.48,3.11-.53,6.39-.53,6.39",
    style: {
      fill: "#facd8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.2,401.45a4.85,4.85,0,0,1-.84,0l-2.4-.15c-2.09-.13-5.11-.27-8.84-.29a146.51,146.51,0,0,0-29,2.8,61.9,61.9,0,0,0-15.2,4.89,34.61,34.61,0,0,0-10.44,7.69,26.92,26.92,0,0,0-4.82,7.32c-.41,1-.69,1.72-.86,2.24a5,5,0,0,1-.28.79,4.35,4.35,0,0,1,.18-.82,20.09,20.09,0,0,1,.78-2.28,25.81,25.81,0,0,1,4.72-7.49,34.47,34.47,0,0,1,10.51-7.88,61.27,61.27,0,0,1,15.31-5,138.15,138.15,0,0,1,29.07-2.65c3.74.06,6.77.26,8.85.45,1,.08,1.85.18,2.4.24A5.29,5.29,0,0,1,202.2,401.45Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.78,403.15a3.81,3.81,0,0,1-.77.06c-.5,0-1.24,0-2.2.05-1.91,0-4.67,0-8.08,0s-7.48-.05-12,.25a88.46,88.46,0,0,0-14.45,2.2A51.76,51.76,0,0,0,156.72,411a65.07,65.07,0,0,0-10.07,6.4,26.26,26.26,0,0,0-5.46,5.86c-1,1.59-1.45,2.57-1.51,2.54a3.36,3.36,0,0,1,.3-.7,16.69,16.69,0,0,1,1-1.95,25.31,25.31,0,0,1,5.39-6,63.15,63.15,0,0,1,10.08-6.53,51.13,51.13,0,0,1,13.68-5.39A86.58,86.58,0,0,1,184.72,403c4.52-.27,8.6-.2,12-.14l8.08.2,2.2,0A6.77,6.77,0,0,1,207.78,403.15Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,406.6a3,3,0,0,1-.62,0l-1.77-.05c-1.54-.05-3.76-.13-6.5-.14a80.15,80.15,0,0,0-21.22,2.37,47.72,47.72,0,0,0-10.85,4.45,38.27,38.27,0,0,0-7.7,5.69,33.15,33.15,0,0,0-4.23,4.89c-.88,1.26-1.32,2-1.36,2a3,3,0,0,1,.28-.55c.21-.35.47-.89.91-1.52a29.77,29.77,0,0,1,4.14-5.05,38.17,38.17,0,0,1,7.72-5.84,46.83,46.83,0,0,1,11-4.53,76.1,76.1,0,0,1,21.35-2.24c2.75.06,5,.19,6.51.3l1.76.15A2.56,2.56,0,0,1,206,406.6Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.9,407.42a1.74,1.74,0,0,1-.47.05l-1.36,0a21,21,0,0,0-2.13.07c-.83.05-1.78.07-2.82.22s-2.18.24-3.39.48-2.5.5-3.84.81a55.1,55.1,0,0,0-8.48,3,55.72,55.72,0,0,0-7.82,4.43c-1.12.81-2.21,1.56-3.14,2.36s-1.82,1.53-2.59,2.25-1.43,1.39-2,2-1.07,1.12-1.45,1.56l-.91,1a1.73,1.73,0,0,1-.34.33s.07-.15.26-.4l.83-1.07a18.61,18.61,0,0,1,1.4-1.63c.57-.61,1.19-1.34,2-2.05s1.6-1.53,2.57-2.31,2-1.59,3.14-2.42a48.5,48.5,0,0,1,16.46-7.49c1.36-.31,2.65-.62,3.89-.78s2.37-.33,3.42-.42,2-.11,2.85-.15,1.56,0,2.15,0l1.35.08A1.47,1.47,0,0,1,204.9,407.42Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.07,401.17a2.18,2.18,0,0,1,.3.49,5.73,5.73,0,0,1,.51,1.57,8.33,8.33,0,0,1-1.31,5.84,10.25,10.25,0,0,1-2.94,3,16.86,16.86,0,0,1-4.36,2.05,35.06,35.06,0,0,1-5.18,1.16c-1.81.3-3.69.55-5.63.73a78,78,0,0,1-19.86-.64c-2.52-.4-4.52-.9-5.9-1.24l-1.58-.45a2.1,2.1,0,0,1-.54-.2,4,4,0,0,1,.57.09l1.59.36c1.4.28,3.4.72,5.92,1.08a83.1,83.1,0,0,0,19.75.48,60.57,60.57,0,0,0,10.72-1.82c3.18-1,5.8-2.68,7.13-4.81a8.33,8.33,0,0,0,1.42-5.62A9.55,9.55,0,0,0,226.07,401.17Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.1,404.09a2.69,2.69,0,0,1-.15.66c-.06.22-.12.49-.23.79l-.41,1a18.37,18.37,0,0,1-4.14,5.8c-4.34,4.19-12.16,8.24-21.41,9a78.55,78.55,0,0,1-12.95,0,67.86,67.86,0,0,1-10.48-1.46,37.34,37.34,0,0,1-6.78-2.23c-.76-.35-1.35-.64-1.74-.86a3.38,3.38,0,0,1-.57-.35,2.9,2.9,0,0,1,.62.26c.4.19,1,.44,1.77.77a41.13,41.13,0,0,0,6.78,2.05,70.9,70.9,0,0,0,10.43,1.34,81.23,81.23,0,0,0,12.87,0c9.14-.71,16.87-4.65,21.2-8.71a18.82,18.82,0,0,0,4.22-5.62c.16-.37.31-.71.45-1s.2-.56.27-.77A5.6,5.6,0,0,1,233.1,404.09Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.19,407.23a11.17,11.17,0,0,1-.54,3.08,16.24,16.24,0,0,1-4.62,7.1,29.84,29.84,0,0,1-11,6.21,61.74,61.74,0,0,1-15.25,2.46,105.32,105.32,0,0,1-28-1.52,70.76,70.76,0,0,1-8.21-2.21c-1-.31-1.68-.62-2.17-.8a3.9,3.9,0,0,1-.74-.32,4.52,4.52,0,0,1,.77.22c.51.15,1.24.42,2.2.7a75.93,75.93,0,0,0,8.23,2,109.26,109.26,0,0,0,27.86,1.37,63.07,63.07,0,0,0,15.14-2.39,30,30,0,0,0,10.85-6,16.43,16.43,0,0,0,4.67-6.9A24.72,24.72,0,0,0,238.19,407.23Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.42,427.76a4.43,4.43,0,0,1,.82.21l2.34.67c2,.57,5,1.39,8.67,2.17a86.1,86.1,0,0,0,29.27,1.51,63.76,63.76,0,0,0,15.62-4.09,35.72,35.72,0,0,0,11.22-6.81,25.1,25.1,0,0,0,5.49-6.94,16,16,0,0,0,.93-2.24,4.87,4.87,0,0,1,.26-.81,1.08,1.08,0,0,1,0,.22c0,.14-.06.35-.13.62a14.55,14.55,0,0,1-.84,2.3,24.41,24.41,0,0,1-5.43,7.12,35.25,35.25,0,0,1-11.29,7,62.52,62.52,0,0,1-15.74,4.17,83.63,83.63,0,0,1-29.41-1.67c-3.69-.83-6.63-1.7-8.65-2.34-1-.32-1.79-.57-2.31-.76A4.63,4.63,0,0,1,168.42,427.76Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.24,434.5a4.59,4.59,0,0,1,.77.37c.5.25,1.2.68,2.17,1.13a54.38,54.38,0,0,0,29.23,5.45,54.16,54.16,0,0,0,8.28-1.46,70.69,70.69,0,0,0,15.19-5.77,42.1,42.1,0,0,0,10.69-7.79,27.76,27.76,0,0,0,5.16-7.27,9.36,9.36,0,0,0,.59-1.28l.38-.95a7.21,7.21,0,0,1,.35-.78,5.17,5.17,0,0,1-.25.81l-.34,1a8.43,8.43,0,0,1-.55,1.31,26.64,26.64,0,0,1-5.08,7.43,41.58,41.58,0,0,1-10.72,8,70.41,70.41,0,0,1-15.29,5.85,54.83,54.83,0,0,1-8.37,1.46,55.46,55.46,0,0,1-7.91.13,53.4,53.4,0,0,1-13.14-2.43,49.57,49.57,0,0,1-8.31-3.48c-1-.48-1.65-.94-2.13-1.22A6.61,6.61,0,0,1,174.24,434.5Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.25,416.16a25.75,25.75,0,0,0-3.48-4.18,27.21,27.21,0,0,0-4.59-3,9.75,9.75,0,0,1,4.93,2.55A9.58,9.58,0,0,1,197.25,416.16Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.9,415.85a12.9,12.9,0,0,1-.62-1.64,9.76,9.76,0,0,0-2.27-3.43,13.64,13.64,0,0,0-3.44-2.33,7.42,7.42,0,0,1-1.57-.81,5,5,0,0,1,1.72.47,11.52,11.52,0,0,1,3.65,2.3,8.6,8.6,0,0,1,2.26,3.67A4.14,4.14,0,0,1,204.9,415.85Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6,415.13c-.17.08-.76-2.53-3-4.73s-4.81-2.8-4.73-3a3.92,3.92,0,0,1,1.65.39,9.68,9.68,0,0,1,5.67,5.67A4,4,0,0,1,212.6,415.13Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.53,402.78a2.64,2.64,0,0,1,.82,0,14.27,14.27,0,0,1,2.24.24,19.65,19.65,0,0,1,12.27,7.77,13.16,13.16,0,0,1,1.17,1.92,2.39,2.39,0,0,1,.32.76c-.08,0-.63-1-1.78-2.45a22,22,0,0,0-5.38-4.85,21.45,21.45,0,0,0-6.68-2.78C202.69,402.93,201.53,402.88,201.53,402.78Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.23,399.61a3.46,3.46,0,0,1,1-.11,10.46,10.46,0,0,1,1.14,0c.45,0,1,0,1.51.11a20.81,20.81,0,0,1,3.87.81,24.71,24.71,0,0,1,4.44,1.93,24.35,24.35,0,0,1,3.91,2.85,20.67,20.67,0,0,1,2.66,2.93,12.3,12.3,0,0,1,.86,1.25,7.81,7.81,0,0,1,.57,1,3.33,3.33,0,0,1,.4.89c-.09,0-.73-1.18-2.12-2.91a24.26,24.26,0,0,0-2.68-2.79,23.35,23.35,0,0,0-8.19-4.68,22.38,22.38,0,0,0-3.76-.9C204.62,399.64,203.23,399.71,203.23,399.61Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.23,399.3s.23-.15.67-.31a13.74,13.74,0,0,1,1.95-.56,20.51,20.51,0,0,1,13.06,1.49,13.86,13.86,0,0,1,1.77,1c.4.27.61.43.59.46s-1-.46-2.51-1.1a23.82,23.82,0,0,0-6.32-1.65,24.13,24.13,0,0,0-6.52.18C209.26,399.07,208.26,399.38,208.23,399.3Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.45,424.86c8.7-4.22,15.4-12,24.44-15.48A51.45,51.45,0,0,0,166,423.65"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.32,421.13a56,56,0,0,0,20.67,1,27.81,27.81,0,0,0,8.63-2.45c2.68-1.35,5.06-2.81,6.36-5.52-10.34,7-20.84,8.51-35.66,6.84"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.34,405.67a40.89,40.89,0,0,0-11.84,6.61c11.36-6.42,17.51-7.67,27-8.85A33.09,33.09,0,0,0,165.34,405.67Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223.31,400l-56,.12a11.34,11.34,0,0,0,7.56,1.35,8.4,8.4,0,0,1,2.16-.26,1.93,1.93,0,0,1,1.72,1.13c.24.69-.09,1.46.09,2.17.31,1.24,1.94,1.57,3.22,1.43s2.7-.5,3.76.24c1.24.88,1.26,2.81,2.4,3.83s2.8.76,4.21.31,2.88-1.08,4.31-.71c2.22.57,3.55,3.38,5.85,3.39,2.12,0,3.59-2.44,5.71-2.58,1.35-.09,2.54.78,3.81,1.22s3.09.19,3.39-1.13c.15-.64-.13-1.39.24-1.94.48-.73,1.59-.49,2.41-.18s1.93.54,2.4-.19c.65-1-.84-2.56,0-3.48.45-.53,1.29-.37,2-.47a2.31,2.31,0,0,0,.87-4.25Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M223.57,400.3a7,7,0,0,0-3.71-1.59l-8-1.69c-7.77-1.64-15.09-4-22.64-1.58l-1.83-1.25c-8.89-3.36-14.75-.09-19.37,2.74a4.74,4.74,0,0,0-1.45,1.08,1.48,1.48,0,0,0,.64,1.93,4.31,4.31,0,0,0,2.2.41l8.07.06a3.5,3.5,0,0,1,1.41.21,1.17,1.17,0,0,1,.73,1.14c-.07.49-.54.81-.78,1.24-.58,1,.25,2.35,1.35,2.72a5.45,5.45,0,0,0,3.39-.31c1.3-.44,3-.84,3.85.24.6.76.43,1.9.91,2.74a2.82,2.82,0,0,0,2.95,1.1,15,15,0,0,0,3.12-1.2,4.35,4.35,0,0,1,3.25-.3c1.34.53,2,2,2.7,3.23s1.93,2.52,3.33,2.24c1.76-.36,2.43-2.9,4.21-3.18,1.55-.24,2.82,1.43,4.39,1.53a2.41,2.41,0,0,0,2.18-3.31,2.05,2.05,0,0,1,2-.32,8,8,0,0,0,2.08.51c.72,0,1.51-.54,1.46-1.25s-.65-1-.73-1.63c-.12-.85.87-1.44,1.73-1.53a5.56,5.56,0,0,0,2.52-.4C224.67,403.15,224.52,401.28,223.57,400.3Z",
    style: {
      fill: "#A9D061"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.49,402.38l-2.55-.82c3.41,2.1,7.86,3.58,11.76,2.62s6.06-3.53,8.1-7C215,400.05,209.58,400.25,203.49,402.38Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M201.82,401.59c-3.48.73-8.24-1.27-11.09-3.38a17.51,17.51,0,0,1-6-8.62,27.27,27.27,0,0,1-1.09-10.52A34.67,34.67,0,0,1,200.4,388c1.86,1.8,2.42,4.1,2.68,6.67s.21,4.85-1.26,6.92",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.79,387.22s.26.07.68.29a13.25,13.25,0,0,1,1.71,1,19.93,19.93,0,0,1,4.65,4.68A31.87,31.87,0,0,1,200,399a11.88,11.88,0,0,1,.92,2.57,18.3,18.3,0,0,1-1.26-2.41,41.39,41.39,0,0,0-3.28-5.62,23.37,23.37,0,0,0-4.44-4.69C190.65,387.82,189.75,387.3,189.79,387.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.94,401.56c3.58,3,11.27,1.64,15.39-.49a19.13,19.13,0,0,0,9-10.19c-5.23-2-11.49-1.4-16.67.74a12.47,12.47,0,0,0-4.82,3.41c-2.22,2.21-2.5,4.12-2.92,6.53",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.6,394.53a25.7,25.7,0,0,0-8,2.08A26.36,26.36,0,0,0,201,401.5a7.7,7.7,0,0,1,1.54-1.93,17.74,17.74,0,0,1,10.58-5.06A7.19,7.19,0,0,1,215.6,394.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.35,390.88c0,.1-1.63-.5-4.35-.79a26.08,26.08,0,0,0-10.5,1.07,17.39,17.39,0,0,0-5.12,2.7,11.37,11.37,0,0,0-3,3.58,11,11,0,0,0-1.16,4.2,3.66,3.66,0,0,1,0-1.2,8.49,8.49,0,0,1,.88-3.17,11.3,11.3,0,0,1,3.08-3.78,16.93,16.93,0,0,1,5.26-2.82,24.57,24.57,0,0,1,10.7-.94,19.79,19.79,0,0,1,3.2.71A4.74,4.74,0,0,1,225.35,390.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.81,403.93a.63.63,0,0,0,0-1.25.63.63,0,0,0,0,1.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.45,401.79a.63.63,0,0,0,0-1.25.63.63,0,0,0,0,1.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M189.89,406.86a.63.63,0,0,0,0-1.25.63.63,0,0,0,0,1.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.52,407.26a3.16,3.16,0,0,1-2.23,1.21,3.09,3.09,0,0,1-2.51-.34c0-.15,1.12.08,2.41-.17S194.43,407.14,194.52,407.26Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M205.81,410.45c.12.07-.16.84-.86,1.55s-1.46,1-1.53.87.53-.59,1.16-1.24S205.68,410.38,205.81,410.45Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M214,408.68c.13-.06.45.64.11,1.44s-1.06,1.06-1.11.92.38-.5.63-1.13S213.87,408.72,214,408.68Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M218.29,405.8c.09-.12.57.18.7.8s-.19,1.1-.31,1-.09-.46-.2-.92S218.19,405.91,218.29,405.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M186,403.89c0,.06-.26.34-.83.68a6.54,6.54,0,0,1-2.43.9,4.51,4.51,0,0,1-2.59-.36c-.61-.3-.87-.64-.83-.68s.38.15,1,.34a5.23,5.23,0,0,0,2.38.18C184.55,404.64,185.93,403.73,186,403.89Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M179.94,400.28c0,.07-.7-.25-1.84-.48a19.81,19.81,0,0,0-4.54-.25,27.07,27.07,0,0,1-4.65-.11,4.23,4.23,0,0,1-1.85-.54,18.64,18.64,0,0,1,1.89.18c1.17.09,2.78,0,4.59-.05a15.22,15.22,0,0,1,4.65.41A4,4,0,0,1,179.94,400.28Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M198,407.28c-.11.1-.42-.07-.81-.15s-.74-.08-.8-.21.35-.43.91-.3S198.1,407.2,198,407.28Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188,397a5.15,5.15,0,0,0-3.53-2.66A20.76,20.76,0,0,0,172,395.68c-.21.09-.43.21-.48.42a.51.51,0,0,0,.35.55,1.46,1.46,0,0,0,.69,0q4.1-.48,8.2-.62a4.12,4.12,0,0,1,2.46.42,9.49,9.49,0,0,1,1.36,1.4,3.94,3.94,0,0,0,2.77,1.12c.44,0,1-.19,1-.63A3,3,0,0,0,188,397Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166.9,409.13l.33-.3-.13.1a3.07,3.07,0,0,1,.68-.39l-.15.06a3,3,0,0,1,.78-.22.6.6,0,0,0,.38-.28.64.64,0,0,0-.23-.86l-.15-.06a.62.62,0,0,0-.33,0,3.67,3.67,0,0,0-2.06,1.06.63.63,0,0,0,.88.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.73,403.34a1.51,1.51,0,0,1-.22.11l.15-.06a3,3,0,0,1-.8.21l.17,0a2.89,2.89,0,0,1-.83,0l.17,0-.14,0a.72.72,0,0,0-.48.06.69.69,0,0,0-.29.38.65.65,0,0,0,.44.77,3.81,3.81,0,0,0,2.46-.37.62.62,0,0,0,.22-.85.63.63,0,0,0-.85-.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.74,407.1A1.35,1.35,0,0,1,201,407l.07,0c.06,0,.05,0,0,0a.21.21,0,0,0,.1,0l.29-.08.15,0h.07c-.12,0,0,0,.07,0h.51l.07,0,.3.07a.63.63,0,0,0,.77-.44.65.65,0,0,0-.44-.77,3.47,3.47,0,0,0-2.81.38.63.63,0,0,0-.23.85.64.64,0,0,0,.86.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.73,411.68a2.11,2.11,0,0,0,2.43,1.67.64.64,0,0,0,.44-.77.64.64,0,0,0-.29-.37l-.15-.07a.62.62,0,0,0-.33,0h0l.16,0h-.34l.17,0a1.64,1.64,0,0,1-.38-.1l.15.06a1.47,1.47,0,0,1-.36-.21l.13.1a1.33,1.33,0,0,1-.29-.29l.1.13a1.29,1.29,0,0,1-.19-.32l.07.15a1.15,1.15,0,0,1-.1-.33.61.61,0,0,0-.28-.37.65.65,0,0,0-.49-.06.63.63,0,0,0-.37.29l-.06.14a.65.65,0,0,0,0,.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.64,407.41c-.17.08,0,0,0,0l.15,0a2.21,2.21,0,0,0,.3-.07h.19l.29,0c.16,0-.12,0,0,0l.16,0,.29.08.08,0,0,0s.11.05.14.07a1.91,1.91,0,0,1,.27.16.62.62,0,0,0,.85-.23.63.63,0,0,0-.22-.85,3.18,3.18,0,0,0-1.52-.52,3.11,3.11,0,0,0-1.59.28.6.6,0,0,0-.28.38.63.63,0,0,0,.06.48.61.61,0,0,0,.37.28.72.72,0,0,0,.48-.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,397s-.72.12-2,.35a37.86,37.86,0,0,0-5.41,1.39A79.35,79.35,0,0,0,143,406.83,52.4,52.4,0,0,0,129.32,419c-1.46,1.86-2.54,3.44-3.25,4.56a18,18,0,0,1-1.13,1.72,3.24,3.24,0,0,1,.22-.49c.17-.31.4-.77.74-1.34a45,45,0,0,1,3.12-4.67,50.35,50.35,0,0,1,13.75-12.38,73.8,73.8,0,0,1,16.69-8,32.68,32.68,0,0,1,5.49-1.24,14.57,14.57,0,0,1,1.52-.14A3,3,0,0,1,167,397Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.55,402.23a1.74,1.74,0,0,1-.53.08l-1.51.11c-1.32.1-3.21.27-5.54.6a59.35,59.35,0,0,0-17.52,5.22,45.73,45.73,0,0,0-14.48,11,41.67,41.67,0,0,0-3.35,4.44,20.21,20.21,0,0,1-1.12,1.71,1.79,1.79,0,0,1,.22-.49c.16-.3.38-.77.73-1.33a35.89,35.89,0,0,1,3.24-4.57,44.1,44.1,0,0,1,14.53-11.26,56.25,56.25,0,0,1,17.7-5.11c2.35-.29,4.26-.41,5.58-.44.66,0,1.17,0,1.52,0Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,405.59a10.59,10.59,0,0,1-1.61.24c-.52.05-1.15.12-1.88.26s-1.56.23-2.46.45-1.91.42-3,.73-2.15.67-3.32,1.06a51.69,51.69,0,0,0-7.24,3.34,50.68,50.68,0,0,0-6.57,4.54c-.93.8-1.83,1.54-2.6,2.32s-1.5,1.48-2.13,2.17-1.16,1.33-1.65,1.89-.87,1.06-1.18,1.48a9.86,9.86,0,0,1-1,1.26,10,10,0,0,1,.86-1.38,16.83,16.83,0,0,1,1.12-1.54c.46-.59,1-1.27,1.6-2s1.3-1.47,2.1-2.23,1.66-1.56,2.6-2.38a49.15,49.15,0,0,1,6.61-4.62,48.36,48.36,0,0,1,7.34-3.34c1.18-.39,2.3-.77,3.37-1a29.69,29.69,0,0,1,3-.68c.92-.2,1.77-.28,2.5-.38s1.38-.15,1.9-.18A9.63,9.63,0,0,1,181,405.59Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.37,408.26a5.59,5.59,0,0,1-1.31.33c-.85.17-2.07.46-3.57.88a52,52,0,0,0-5.15,1.73,53,53,0,0,0-6,2.88,53.94,53.94,0,0,0-5.55,3.65,51,51,0,0,0-4.15,3.52c-1.12,1.07-2,2-2.58,2.61a5.69,5.69,0,0,1-1,.95,6.84,6.84,0,0,1,.81-1.08A31.73,31.73,0,0,1,162.4,421a43,43,0,0,1,4.1-3.64,45.22,45.22,0,0,1,11.67-6.59,43.52,43.52,0,0,1,5.23-1.65,35.27,35.27,0,0,1,3.62-.72A8.38,8.38,0,0,1,188.37,408.26Z",
    style: {
      fill: "#f6ad5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.7,412.1c.09.13-1.72,1.62-3.62,3.78s-3.19,4.11-3.33,4a14.58,14.58,0,0,1,2.94-4.38A14.42,14.42,0,0,1,136.7,412.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.74,413.43c.08.14-1.29,1-2.56,2.41s-2,2.89-2.1,2.83a7.83,7.83,0,0,1,4.66-5.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48,412.5c.09.13-1.7,1.45-3.62,3.38s-3.24,3.72-3.37,3.64a17.79,17.79,0,0,1,7-7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.19,414.69c.06.15-2.09,1.15-4.37,2.93s-3.82,3.6-3.94,3.5a12.43,12.43,0,0,1,3.62-3.91A12.67,12.67,0,0,1,153.19,414.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.78,416.46a15,15,0,0,1-2.11,2.17,14.87,14.87,0,0,1-2.18,2.1,6.35,6.35,0,0,1,1.81-2.46A6.7,6.7,0,0,1,157.78,416.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.32,417.47c.06.14-1.3.91-2.75,2.14S158.11,422,158,422a7.06,7.06,0,0,1,2.25-2.74A7,7,0,0,1,163.32,417.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.06,418c.09.12-.94.93-2.16,2a12,12,0,0,1-2.29,1.81,10.46,10.46,0,0,1,4.45-3.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.88,395A21.92,21.92,0,0,0,169.75,397a7.92,7.92,0,0,1,2.08-1.34,18.06,18.06,0,0,1,5.74-1.7,17.72,17.72,0,0,1,6,.29A7.56,7.56,0,0,1,185.88,395Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,424.34a9.71,9.71,0,0,1-2.4.14c-1.48,0-3.53-.07-5.79-.26s-4.29-.48-5.75-.74a10.54,10.54,0,0,1-2.34-.55,11.66,11.66,0,0,1,2.39.18c1.47.17,3.5.39,5.74.59s4.29.32,5.76.41A12.46,12.46,0,0,1,195,424.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.61,420.06a7.86,7.86,0,0,1-2.12.38,39.32,39.32,0,0,1-10.39-.29,7.47,7.47,0,0,1-2.1-.51c0-.15,3.27.37,7.3.48S204.6,419.9,204.61,420.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,415.93c-.11-.12,1.25-1.37,2.43-3.26s1.74-3.64,1.89-3.6a7.9,7.9,0,0,1-1.45,3.88A8,8,0,0,1,233,415.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.42,418.72c-.1-.13,1-1,1.87-2.42s1.2-2.77,1.35-2.74a6,6,0,0,1-3.22,5.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.39,422.08a153.72,153.72,0,0,1,3.28-4.47,5.19,5.19,0,0,1-1.24,2.53C242.51,421.41,241.49,422.19,241.39,422.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.18,423.85c-.09-.12.33-.56.72-1.16s.64-1.16.78-1.12.11.71-.34,1.41S248.25,424,248.18,423.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.09,415.34c0,.14-.71.2-1.56.13s-1.53-.25-1.52-.39.71-.2,1.57-.13S201.11,415.19,201.09,415.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.4,414.61c0,.15-.35.3-.81.35s-.85,0-.86-.17.35-.3.81-.35S208.39,414.47,208.4,414.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.2,412.94c0,.15-.65.31-1.46.5s-1.48.34-1.53.21.56-.51,1.41-.71S217.19,412.8,217.2,412.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.91,390.73a22.61,22.61,0,0,0-14.16-8.54,8.07,8.07,0,0,1,2.5.25,18.42,18.42,0,0,1,10.27,6.19A7.74,7.74,0,0,1,200.91,390.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.6,392.38c0,.15-1.6.66-3.38,1.77s-3,2.32-3.1,2.21A7.45,7.45,0,0,1,206,393.7,7.32,7.32,0,0,1,209.6,392.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.91,424.63v2.55l33,15.39s2.85,18.28,26.87,18.69,81.85,0,81.85,0,19.95,1.67,26.06-18.28l31.55-15.32-.4-3.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.05,
    y: 461.44,
    width: 77.21,
    height: 3.42,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.22,442.9a1.6,1.6,0,0,1-.35,0l-1,.05-3.95.1-14.5.27c-12.24.19-29.16.37-47.84.4s-35.61-.12-47.86-.41c-6.12-.16-11.07-.29-14.49-.47l-3.94-.19-1-.07-.35,0h1.37l3.94.1c3.43.11,8.38.19,14.5.3,12.24.2,29.16.29,47.85.26s35.59-.16,47.84-.25l14.5-.1h5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.35,462.18c0,.15-17.12.26-38.23.26s-38.25-.11-38.25-.26,17.12-.26,38.25-.26S224.35,462,224.35,462.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.52,427.66c0,.14-44.51.26-99.42.26s-99.43-.12-99.43-.26,44.51-.26,99.43-.26S285.52,427.52,285.52,427.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.33,424.49a3.09,3.09,0,0,1,.26-.77,6.81,6.81,0,0,0,.5-2.17,4.83,4.83,0,0,0-1.18-3.11,8.89,8.89,0,0,0-3.93-1.93l-.23-.07.09-.24a3.45,3.45,0,0,0-.7-3.2,4,4,0,0,0-1.41-1.16,2.24,2.24,0,0,0-1.78,0l-.47.17.13-.48a2.66,2.66,0,0,0-.2-1.62,3.52,3.52,0,0,0-1.64-1.93,3.69,3.69,0,0,0-2.45.1l-.35.11,0-.36c.13-2.67-3.14-4.4-4.77-3.12l-.23.18-.08-.29a3.53,3.53,0,0,0-1.84-2.33,4.61,4.61,0,0,0-2.29-.47,8.42,8.42,0,0,0-2,.41s.15-.12.48-.27a5,5,0,0,1,1.53-.37,4.77,4.77,0,0,1,2.45.41,3.87,3.87,0,0,1,2.08,2.51l-.31-.11a2.79,2.79,0,0,1,1.69-.53,4,4,0,0,1,1.81.54,3.85,3.85,0,0,1,2,3.46l-.33-.25a4.18,4.18,0,0,1,2.8-.1,2.87,2.87,0,0,1,1.18.93,5.31,5.31,0,0,1,.75,1.28,3.12,3.12,0,0,1,.22,1.95l-.34-.31a2.77,2.77,0,0,1,2.17.07,4.52,4.52,0,0,1,1.6,1.32,3.94,3.94,0,0,1,.73,3.69l-.14-.31a9.05,9.05,0,0,1,4.07,2.12,5,5,0,0,1,1.16,3.37,5.85,5.85,0,0,1-.64,2.21A3.52,3.52,0,0,1,251.33,424.49Z",
    style: {
      fill: "#f6ad5f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Glass--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.29,411.12c-13.77-3.09-23.93-11.73-26.64-28.87-2.95-18.68,10.42-50,10.42-50l24.93.14,21.24.27s13.13,31.36,10.05,50-14.94,26.61-30.64,28.91h0l-1.58,2.7L339.36,471l23.14,5.83a.62.62,0,0,1-.23,1.2L310,477.75a.62.62,0,0,1-.21-1.2L333,470.66l.71-56.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.29,411.12s.13.26.37.81.61,1.38,1.1,2.47h0c-.08,7.57-.28,27.5-.58,56.25v.13l-.13,0-23.26,5.91h0a.43.43,0,0,0,0,.8c.43,0,1,0,1.54,0l3.2,0,6.55,0,13.64.06,14.31.05,7.39,0,3.75,0h1.89c.33,0,.44-.05.53-.26a.36.36,0,0,0-.21-.48h0l-23.14-5.81-.19-.05V471c.22-17.8.46-36.92.7-56.69v-.07l0-.06c.5-.85,1-1.78,1.58-2.7l.06-.11.12,0a55.19,55.19,0,0,0,6.66-1.42A36.18,36.18,0,0,0,359,405a27.92,27.92,0,0,0,8-8.41,39.51,39.51,0,0,0,5.43-21.93,100.47,100.47,0,0,0-3.7-21.81A180.47,180.47,0,0,0,362,332.72l.21.15-24-.3-22.18-.14.19-.12a180.26,180.26,0,0,0-6.67,19.24,114.49,114.49,0,0,0-3.74,17.86,57,57,0,0,0-.42,8.26v1l.1,1c.07.65.13,1.29.19,1.93.13,1.27.44,2.49.64,3.7a37.18,37.18,0,0,0,5.12,12.38,28.93,28.93,0,0,0,7.51,7.7,32.42,32.42,0,0,0,7,3.77l1.42.55,1.27.41,1.08.36.91.24c1.08.28,1.62.44,1.62.44s-.57-.12-1.65-.39l-.9-.22-1.09-.34-1.27-.39-1.43-.55a31.73,31.73,0,0,1-7.06-3.73,29,29,0,0,1-7.59-7.71,37.32,37.32,0,0,1-5.21-12.45c-.21-1.22-.53-2.45-.66-3.73-.06-.64-.13-1.29-.2-1.95l-.1-1v-1a57.51,57.51,0,0,1,.39-8.31,116.48,116.48,0,0,1,3.71-17.93,180.29,180.29,0,0,1,6.66-19.3l.05-.13h.14l22.19.1,24,.27h.16l.06.15a180.73,180.73,0,0,1,6.78,20.17A100.48,100.48,0,0,1,373,374.63a39.9,39.9,0,0,1-5.5,22.22,28.18,28.18,0,0,1-8.15,8.56,36.39,36.39,0,0,1-10.91,5,52.87,52.87,0,0,1-6.72,1.43l.19-.12c-.55.93-1.09,1.85-1.58,2.71l0-.13c-.25,19.77-.49,38.89-.72,56.69l-.19-.25,23.14,5.84h0a.85.85,0,0,1,.08,1.56,1,1,0,0,1-.57.09h-1.89l-3.75,0-7.39,0-14.31-.08L321.12,478l-6.55,0-3.21,0c-.55,0-1,0-1.63,0a.82.82,0,0,1-.05-1.56h0L333,470.49l-.14.17c.43-28.74.73-48.67.84-56.24v0c-.47-1.1-.82-1.92-1.05-2.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.12,380.57c-13.07-.16-18.6-9.19-27.06-9.29s-12,7.88-12,7.88c2.67,17.28,13.37,25.23,27.59,27.36l4.35,0a10.67,10.67,0,0,0,1.59-.14c13.84-2.28,24.17-9.87,26.92-26.82C369.47,379.53,356.92,380.68,348.12,380.57Z",
    style: {
      fill: "#A9D061"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.7,332.27a9,9,0,0,0,1.54,1.2,36,36,0,0,0,4.61,2.63,39.64,39.64,0,0,0,34,.15,35.09,35.09,0,0,0,4.63-2.6,7.94,7.94,0,0,0,1.55-1.18c-.08-.12-2.32,1.52-6.39,3.3a41.19,41.19,0,0,1-33.59-.14C318,333.82,315.78,332.15,315.7,332.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.48,381.71a7,7,0,0,0,.45,1.72,25.92,25.92,0,0,0,2,4.4,28.56,28.56,0,0,0,26.74,14.49,25.66,25.66,0,0,0,4.78-.73,7.11,7.11,0,0,0,1.68-.56,58.6,58.6,0,0,1-6.48.77,29.26,29.26,0,0,1-26.27-14.23A56,56,0,0,1,312.48,381.71Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastaPana3);
export default __webpack_public_path__ + "static/media/Pasta-pana(3).547c77a5d2aa0189bb26a661ab244eb8.svg";
export { ForwardRef as ReactComponent };